module.exports = "/_next/static/images/a1fff3087f5870a9138878171881059f-two-people-looking-xs@1x.jpg.webp";